// Generated by ReScript, PLEASE EDIT WITH CARE

import * as JsxRuntime from "react/jsx-runtime";
import * as BsCssJs$PrezzeeRibbon from "../../../bindings/BsCss/BsCssJs.bs.js";
import * as Theme__Responsive$PrezzeeRibbon from "../../../theme/Theme__Responsive.bs.js";

var container = BsCssJs$PrezzeeRibbon.style([
      BsCssJs$PrezzeeRibbon.marginRight(BsCssJs$PrezzeeRibbon.rem(0.375)),
      BsCssJs$PrezzeeRibbon.selector("&:last-of-type", [BsCssJs$PrezzeeRibbon.marginRight(BsCssJs$PrezzeeRibbon.px(0))]),
      BsCssJs$PrezzeeRibbon.selector("a", [
            BsCssJs$PrezzeeRibbon.display("block"),
            BsCssJs$PrezzeeRibbon.media(Theme__Responsive$PrezzeeRibbon.mobile, [BsCssJs$PrezzeeRibbon.maxHeight(BsCssJs$PrezzeeRibbon.px(70))]),
            BsCssJs$PrezzeeRibbon.selector("&:hover", [BsCssJs$PrezzeeRibbon.opacity(0.7)])
          ]),
      BsCssJs$PrezzeeRibbon.selector("img", [
            BsCssJs$PrezzeeRibbon.width(BsCssJs$PrezzeeRibbon.pct(100.0)),
            BsCssJs$PrezzeeRibbon.height("auto"),
            BsCssJs$PrezzeeRibbon.media(Theme__Responsive$PrezzeeRibbon.tabletOrDesktop, [
                  BsCssJs$PrezzeeRibbon.maxHeight(BsCssJs$PrezzeeRibbon.px(55)),
                  BsCssJs$PrezzeeRibbon.width("auto")
                ])
          ])
    ]);

var Styles = {
  container: container
};

function DownloadAppsBanner__AppBadge(props) {
  return JsxRuntime.jsx("div", {
              children: props.children,
              className: container
            });
}

var make = DownloadAppsBanner__AppBadge;

export {
  Styles ,
  make ,
}
/* container Not a pure module */
